import { useEffect } from "react";
import { ConfigProvider } from "antd";
import { VenueTheme } from "enums";
import { getDefaultTheme, getVenueTheme } from "services/venue.service";

// antd's primary color for each design system. antd reads it from CSS variables
// (antd.variable.css), so it can change at runtime along with our own tokens.
const antdPrimaryColor = {
  [VenueTheme.Socashless]: "#1890ff",
  [VenueTheme.Soar]: "#a05a50",
};

export const applyTheme = (theme) => {
  document.documentElement.setAttribute("data-theme", theme);
  ConfigProvider.config({ theme: { primaryColor: antdPrimaryColor[theme] } });
};

// Draws the dashboard in the venue's design system: sets `data-theme` on <html>, which
// switches the tokens in themes/, and retints antd. Leaving the venue restores the default
// (DEFAULT_SYSTEM_DESIGN).
const useVenueTheme = (venue) => {
  const theme = getVenueTheme(venue);

  useEffect(() => {
    applyTheme(theme);
    return () => applyTheme(getDefaultTheme());
  }, [theme]);
};

export default useVenueTheme;
